module.exports = __webpack_public_path__ + "static/media/blazej-ios.bd4ad89b.png";